import { useCallback, useState } from 'react';
import salesforceTasksService from 'services/salesforceTasksService';

const useSalesforceTaskUpdate = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	// Update a task in Salesforce and expose user-friendly errors
	const updateTask = useCallback(
		async ({ taskId, due_date, status, comments }) => {
			setLoading(true);
			setError(null);

			try {
				return await salesforceTasksService.updateTask(taskId, {
					due_date,
					status,
					comments,
				});
			} catch (err) {
				const message = getFriendlyErrorMessage(err);

				setError(message);
				throw new Error(message);
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	return {
		updateTask,
		loading,
		error,
	};
};

// Map backend error responses to user-friendly messages
const getFriendlyErrorMessage = (err) => {
	const message =
		err?.response?.data?.error || err?.error || err?.message || '';

	switch (message) {
		case 'Invalid due_date':
			return 'Invalid due date.';

		case 'due_date cannot be in the past':
			return 'The due date cannot be in the past.';

		case 'Invalid status':
			return 'Please select a valid task status.';

		case 'Task not found':
			return 'This task could not be found.';

		case 'Salesforce not connected':
			return 'Your CRM is no longer connected.';

		default:
			return message || 'Unable to update the CRM task.';
	}
};

export default useSalesforceTaskUpdate;
